import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	root: {
		borderTopLeftRadius: 4,
		borderBottomLeftRadius: 4,
		background: 'rgba(255, 255, 255, 0.2)'
	},
	icon: {
		marginBottom: -2
	}
}));

export default useStyles;
